import Lottie from 'lottie-react';
import { useState, useEffect, useContext, useRef } from 'react';
import LoginLottie from "../../assets/Lottie/1st.json";
import { getCountries, getCountryCallingCode } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getExampleNumber } from "libphonenumber-js";
import examples from "libphonenumber-js/examples.mobile.json";
import { MyContext } from '../../Context/MyProvider';
import BtnLoader from '../BtnLoader';
import secureLocalStorage from 'react-secure-storage';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const Index = () => {

    const [pageStep, setPageStep] = useState(1);
    const [number, setNumber] = useState("");
    const [selectCcode, setSelectCcode] = useState("+91");

    const navigate = useNavigate();

    return (
        <div className="h-screen grid grid-cols-1 lg:grid-cols-2">

            <div className="flex-1 flex items-center justify-center p-6 lg:p-12 relative">

                <button onClick={() => navigate("/")} className='absolute top-5 right-8'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="black" />
                    </svg>
                </button>

                {pageStep === 1 && <Login setPageStep={setPageStep} number={number} selectCcode={selectCcode} setNumber={setNumber} setSelectCcode={setSelectCcode} />}
                {pageStep === 2 && <Signup setPageStep={setPageStep} number={number} selectCcode={selectCcode} />}

            </div>

            <div className="hidden lg:flex bg-[--bg-color] items-center">
                <Lottie
                    className="w-[500px] mx-auto mb-[20px]"
                    animationData={LoginLottie}
                    loop={true}
                />
            </div>
        </div>
    )
}

export default Index

const Login = ({ setPageStep, number, setNumber, selectCcode, setSelectCcode }) => {
    const { t } = useTranslation();

    const { handleCallApi, setShowToast, setToastMsg, setIsAuth } = useContext(MyContext);

    const [apiLoading, setApiLoading] = useState("");
    const [password, setPassword] = useState("");
    const [digits, setDigits] = useState("");
    const [showCcode, setShowCcode] = useState(false);
    const [searchCcode, setSearchCcode] = useState("");
    const [passtype, setPassType] = useState("Password");
    const [showPassInput, setShowPassInput] = useState(false);
    const [sendOtp, setSendOtp] = useState("");
    const [sessionId, setSessionId] = useState("");
    const [inputFild, setInputFild] = useState(Array(6).fill(""));
    const [resendTimer, setResendTimer] = useState(0);
    const [otpProvider, setOtpProvider] = useState("");

    const navigate = useNavigate();
    const InputRef = useRef(Array({ length: 6 }, () => null));

    const countries = getCountries();
    const FilterCCode = countries.filter((item) => getCountryCallingCode(item).toString().includes(searchCcode));

    useEffect(() => {
        getMobileLengthFromCallingCode("IN");
    }, []);

    useEffect(() => {
        let interval = null;
        if (resendTimer > 0) {
            interval = setInterval(() => {
                setResendTimer((prev) => prev - 1);
            }, 1000);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [resendTimer]);

    const handleSelectCuntryCode = async (item) => {
        setSelectCcode(`+${getCountryCallingCode(item)}`);
        getMobileLengthFromCallingCode(item);
        setShowCcode(false);
    }

    const getMobileLengthFromCallingCode = (country) => {
        const exampleNumber = getExampleNumber(country.toUpperCase(), examples);
        if (exampleNumber) {
            setDigits(exampleNumber.nationalNumber.length);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (sendOtp) {
            handleCheckOtp();
            return;
        }

        if (!number) {
            setShowToast(true);
            setToastMsg("Please enter phone number !!");
            return;
        }

        if (showPassInput && !password) {
            setShowToast(true);
            setToastMsg("Please enter password !!");
            return;
        }

        handleCheckNumber();
    }

    const handleCheckNumber = async () => {
        setApiLoading("Continue");
        const Response = await handleCallApi("Post", "customer/mobile_check", { ccode: selectCcode, phone: number });
        if (Response.data.ResponseCode === 200) {
            const Response = await handleCallApi("Get", "customer/otp_detail");
            const provider = Response.data.message;
            setOtpProvider(provider);
            if (provider === "MSG91") {
                handleSendOtpMSG91();
            } else {
                handleSendOtpTwilo();
            }
        } else {
            if (showPassInput) {
                handleLogIn();
                return;
            }
            setShowPassInput(true);
        }
        setApiLoading("");
    }

    const handleSendOtpMSG91 = async () => {
        const Response = await handleCallApi("Post", "customer/msg91", { phoneno: `${selectCcode}${number}` });
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            setSessionId(Response.data.session_id);
            setResendTimer(60);
            if (Response.data.otp) {
                setSendOtp(Response.data.otp);
                setInputFild(Response.data.otp.toString().split(""));
            } else {
                setSendOtp("REQUIRED"); // placeholder to advance view step
                setInputFild(Array(6).fill(""));
            }
        }
    }

    const handleSendOtpTwilo = async () => {
        const Response = await handleCallApi("Post", "customer/twilio", { phoneno: `${selectCcode}${number}` });
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            setSessionId(Response.data.session_id);
            setResendTimer(60);
            if (Response.data.otp) {
                setSendOtp(Response.data.otp);
                setInputFild(Response.data.otp.toString().split(""));
            } else {
                setSendOtp("REQUIRED"); // placeholder to advance view step
                setInputFild(Array(6).fill(""));
            }
        }
    }

    const handleResendOtp = () => {
        if (otpProvider === "MSG91") {
            handleSendOtpMSG91();
        } else {
            handleSendOtpTwilo();
        }
    }

    const handleLogIn = async () => {
        setApiLoading("Continue");
        const Response = await handleCallApi("Post", "customer/login", { ccode: selectCcode, phone: number, password });
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            secureLocalStorage.setItem("Logindata", JSON.stringify(Response.data.customer_data));
            secureLocalStorage.setItem("Userid", Response.data.customer_data.id);
            secureLocalStorage.setItem("isauth", true);
            setIsAuth(true);
            navigate("/");
        }
        setApiLoading("");
    }

    const handleOnChange = (value, index) => {
        const Copy = [...inputFild];
        Copy[index] = value;
        setInputFild(Copy);

        if (value && !isNaN(value) && index < InputRef.current.length - 1) {
            InputRef.current[index + 1].focus();
        }
    }

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && index > 0 && !e.target.value) {
            InputRef.current[index - 1].focus();
        }
    }

    const handleCheckOtp = async () => {
        setApiLoading("Verify OTP");
        const Response = await handleCallApi("Post", "customer/verify_otp", {
            session_id: sessionId,
            otp: inputFild.join("")
        });
        setApiLoading("");
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            setPageStep((prev) => prev + 1);
        }
    }

    return <div className="w-full max-w-lg">

        <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">
                {sendOtp ? t("Enter OTP Code") : t("Welcome To Your ZippyGo Ride!")}
            </h1>
            <p className="text-gray-500">
                {sendOtp ? `${t("OTP hase been sent to your mobile number")} ${selectCcode + number}` : t("Book a ride in just a few taps and reach your destination comfortably.")}
            </p>
        </div>

        <form onSubmit={handleSubmit}>

            {!sendOtp && <div>
                <label className="font-semibold text-gray-800">{t("Phone number")}</label>
                <div className="flex items-center gap-3 relative mt-1">
                    <div onClick={() => setShowCcode(!showCcode)} className="flex items-center gap-2 border p-[8px] rounded-[10px] cursor-pointer">
                        <span>{selectCcode}</span>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 14.75C11.808 14.75 11.616 14.6771 11.47 14.5301L7.46999 10.5301C7.17699 10.2371 7.17699 9.76202 7.46999 9.46902C7.76299 9.17602 8.23803 9.17602 8.53103 9.46902L12.001 12.939L15.471 9.46902C15.764 9.17602 16.239 9.17602 16.532 9.46902C16.825 9.76202 16.825 10.2371 16.532 10.5301L12.532 14.5301C12.384 14.6771 12.192 14.75 12 14.75Z" fill="black" />
                        </svg>
                    </div>
                    <input type="tel" maxLength={digits} value={number} onChange={(e) => setNumber(e.target.value)} className="w-full px-[10px] py-[8px] border rounded-[10px] focus-within:ring-2 focus-within:ring-[--bg-color] transition-all outline-none" placeholder={t("Enter phone number")} />
                    {showCcode && <div className="absolute z-[666] top-10 left-0">
                        <div className="w-[100px] bg-white border border-gray-400">
                            <input type="number" value={searchCcode} onChange={(e) => setSearchCcode(e.target.value)} className="w-full px-[10px] py-[2px] outline-none border-b" placeholder="Search" />
                            <ul className="max-h-[200px] scroll-container">
                                {FilterCCode.map((item, index) => {
                                    return <li key={index} onClick={() => handleSelectCuntryCode(item)} className="px-[10px] py-[2px] cursor-pointer hover:bg-gray-200">+{getCountryCallingCode(item)}</li>
                                })}
                            </ul>
                        </div>
                    </div>}
                </div>
            </div>}

            {showPassInput && <div className="mt-4">
                <label className="font-semibold text-gray-800">{t("Password")}</label>
                <div className="w-full border px-[15px] rounded-[10px] focus-within:ring-2 focus-within:ring-[--bg-color] transition-all flex items-center mt-1">
                    <input type={passtype} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full outline-none py-[8px]" placeholder={t("Enter password")} />
                    {passtype === "Password"
                        ? <svg onClick={() => setPassType("text")} className="cursor-pointer text-gray-500" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.229 13.8679C19.913 16.0639 16.96 19.75 12 19.75C11.037 19.75 10.0861 19.604 9.17408 19.315C8.77908 19.19 8.56105 18.769 8.68605 18.374C8.81005 17.978 9.23496 17.762 9.62696 17.885C10.392 18.127 11.19 18.25 12 18.25C16.222 18.25 18.7901 15.02 19.9441 13.094C20.3521 12.418 20.3521 11.581 19.9461 10.907C19.6001 10.324 19.177 9.72798 18.72 9.17898C18.455 8.85998 18.4991 8.38707 18.8181 8.12307C19.1381 7.85807 19.61 7.90199 19.875 8.21999C20.381 8.82899 20.8509 9.49199 21.2329 10.137C21.9259 11.284 21.926 12.7159 21.229 13.8679ZM10.063 14.9981L3.53004 21.531C3.38404 21.677 3.19201 21.751 3.00001 21.751C2.80801 21.751 2.61598 21.678 2.46998 21.531C2.17698 21.238 2.17698 20.763 2.46998 20.47L5.64503 17.2949C4.31703 16.1499 3.35205 14.837 2.76905 13.866C2.07505 12.716 2.07501 11.2841 2.77101 10.1331C4.08701 7.93708 7.04001 4.251 12 4.251C13.835 4.251 15.565 4.76994 17.155 5.78494L20.469 2.47097C20.762 2.17797 21.237 2.17797 21.53 2.47097C21.823 2.76397 21.823 3.23901 21.53 3.53201L10.065 14.9971C10.065 14.9971 10.065 14.9981 10.064 14.9981C10.063 14.9981 10.063 14.9971 10.063 14.9981ZM9.6089 13.3311L13.3311 9.60891C12.9291 9.38191 12.478 9.251 12 9.251C10.484 9.251 9.25099 10.484 9.25099 12.001C9.25099 12.478 9.3829 12.9291 9.6089 13.3311ZM6.70704 16.232L8.51905 14.4199C8.02405 13.7169 7.75099 12.882 7.75099 11.999C7.75099 9.65605 9.65701 7.74905 12 7.74905C12.884 7.74905 13.7179 8.02211 14.4209 8.51711L16.052 6.88601C14.787 6.14501 13.432 5.74807 12 5.74807C7.77801 5.74807 5.20992 8.97808 4.05592 10.9041C3.64792 11.5801 3.64797 12.4171 4.05397 13.0911C4.59097 13.9881 5.48304 15.201 6.70704 16.232ZM14.708 12.4351C14.528 13.5951 13.594 14.53 12.436 14.709C12.027 14.772 11.7461 15.155 11.8091 15.564C11.8671 15.935 12.1861 16.2 12.5491 16.2C12.5871 16.2 12.6261 16.1969 12.6641 16.1909C14.4911 15.9089 15.908 14.4921 16.19 12.6641C16.253 12.2541 15.973 11.8721 15.563 11.8081C15.163 11.7471 14.771 12.0251 14.708 12.4351Z" fill="currentColor" />
                        </svg>
                        : <svg onClick={() => setPassType("Password")} className="cursor-pointer text-gray-500" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.2352 10.1379C19.9222 7.93894 16.9751 4.25 12.0001 4.25C7.02511 4.25 4.07801 7.93894 2.76501 10.1379C2.07801 11.2859 2.07801 12.7131 2.76501 13.8621C4.07801 16.0611 7.02511 19.75 12.0001 19.75C16.9751 19.75 19.9222 16.0611 21.2352 13.8621C21.9222 12.7131 21.9222 11.2869 21.2352 10.1379ZM19.9481 13.092C18.7981 15.018 16.2351 18.25 12.0001 18.25C7.76511 18.25 5.20212 15.019 4.05212 13.092C3.65012 12.418 3.65012 11.581 4.05212 10.907C5.20212 8.98098 7.76511 5.74902 12.0001 5.74902C16.2351 5.74902 18.7981 8.97998 19.9481 10.907C20.3511 11.582 20.3511 12.418 19.9481 13.092ZM12.0001 7.75C9.65611 7.75 7.75011 9.657 7.75011 12C7.75011 14.343 9.65611 16.25 12.0001 16.25C14.3441 16.25 16.2501 14.343 16.2501 12C16.2501 9.657 14.3441 7.75 12.0001 7.75ZM12.0001 14.75C10.4831 14.75 9.25011 13.517 9.25011 12C9.25011 10.483 10.4831 9.25 12.0001 9.25C13.5171 9.25 14.7501 10.483 14.7501 12C14.7501 13.517 13.5171 14.75 12.0001 14.75Z" fill="currentColor" />
                        </svg>
                    }
                </div>
            </div>}

            {sendOtp && <div className="flex items-center justify-center gap-3 mb-8">
                {inputFild.map((value, index) => {
                    return <input type="tel" key={index}
                        value={value}
                        autoComplete="one-time-code"
                        ref={(e) => InputRef.current[index] = e}
                        onChange={(e) => handleOnChange(e.target.value, index)}
                        onKeyDown={(e) => handleKeyDown(e, index)}
                        className="w-[50px] h-[50px] border-2 font-bold rounded-[10px] text-center outline-[--bg-color] transition-all"
                        maxLength={1} />
                })}
            </div>}

            {sendOtp && (
                <div className="flex justify-center mb-6">
                    {resendTimer > 0 ? (
                        <span className="text-gray-500 font-medium">
                            {t("Resend OTP in")} {resendTimer}s
                        </span>
                    ) : (
                        <button
                            type="button"
                            onClick={handleResendOtp}
                            className="text-[--bg-color] font-semibold hover:underline"
                        >
                            {t("Resend OTP")}
                        </button>
                    )}
                </div>
            )}

            {!sendOtp && <div className="flex justify-end my-4">
                <Link to="/auth/forgot-password" className="font-medium cursor-pointer text-[14px] md:text-[16px]">{t("Forgot Password?")}</Link>
            </div>}


            <button type="submit" className="w-full h-[45px] bg-[--bg-color] text-white rounded-[10px] font-semibold italic tracking-[1px] hover:bg-[--bg-color-hover] transition-colors">
                {apiLoading === "Continue"
                    ? <BtnLoader CustomeStyle={"bg-white"} />
                    : (sendOtp ? t("Verify OTP") : t("Continue"))}
            </button>

        </form>

        {sendOtp && <div className="flex items-center justify-center mt-4 group text-gray-800">
            <button onClick={() => setSendOtp("")} className="flex items-center gap-2">
                <svg width="18" height="18" className="group-hover:text-black" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="currentColor" />
                </svg>
                <span className="group-hover:text-black">{t("Back")}</span>
            </button>
        </div>}

        {!sendOtp && <p className="text-center mt-4 text-gray-600"> {t("By clicking continue. You agree to our")}
            <Link to="/pages/terms-&-conditions" className="hover:text-[--bg-color] text-[--bg-color-hover] ms-2 font-medium cursor-pointer hover:underline">{t("Terms & Conditions")}</Link>
        </p>}

        {showCcode && <div onClick={() => setShowCcode(false)} className="w-full h-[100vh] top-0 fixed z-[555]"></div>}


    </div>
}

const Signup = ({ setPageStep, number, selectCcode }) => {
    const { t } = useTranslation();
    const { handleCallApi, setShowToast, setToastMsg, setIsAuth } = useContext(MyContext);

    const [allData, setAllData] = useState({ name: "", email: "", password: "", refercode: "" });
    const [passtype, setPassType] = useState("Password");
    const [apiLoading, setApiLoading] = useState("");

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const { name, email, password, refercode } = allData;

        if (!name || !email || !password) {
            setShowToast(true);
            setToastMsg("Please fill all details !!");
            return;
        }

        setApiLoading("LetsGo");
        const Response = await handleCallApi("Post", "customer/signup", { name, email, password, referral_code: refercode || "", phone: number, ccode: selectCcode })
        setShowToast(true);
        setToastMsg(Response.data.message);
        if (Response.data.ResponseCode === 200) {
            secureLocalStorage.setItem("Logindata", JSON.stringify(Response.data.customer_data));
            secureLocalStorage.setItem("Userid", Response.data.customer_data.id);
            secureLocalStorage.setItem("isauth", true);
            setIsAuth(true);
            navigate("/");
        }
        setApiLoading("");
    }

    return <div className="w-full max-w-lg">

        <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">{t("Register Your Account")}</h1>
            <p className="text-gray-500">{t("Enter your information below.")}</p>
        </div>

        <form onSubmit={handleSubmit}>

            <div className="space-y-3">
                <div>
                    <label className="font-semibold text-gray-800">{t("Full Name")}</label>
                    <input type="text" value={allData?.name} onChange={(e) => setAllData({ ...allData, name: e.target.value })} className="w-full px-[10px] py-[8px] border rounded-[10px] mt-1 focus-within:ring-2 focus-within:ring-[--bg-color] transition-all outline-none" placeholder={t("Enter full name")} />
                </div>
                <div>
                    <label className="font-semibold text-gray-800">{t("Email Address")}</label>
                    <input type="text" value={allData?.email} onChange={(e) => setAllData({ ...allData, email: e.target.value })} className="w-full px-[10px] py-[8px] border rounded-[10px] mt-1 focus-within:ring-2 focus-within:ring-[--bg-color] transition-all outline-none" placeholder={t("Enter email address")} />
                </div>
                <div>
                    <label className="font-semibold text-gray-800">{t("Password")}</label>
                    <div className="w-full border px-[15px] rounded-[10px] focus-within:ring-2 focus-within:ring-[--bg-color] transition-all flex items-center">
                        <input type={passtype} value={allData.password} onChange={(e) => setAllData({ ...allData, password: e.target.value })} className="w-full outline-none py-[8px]" placeholder={t("Enter password")} />
                        {passtype === "Password"
                            ? <svg onClick={() => setPassType("text")} className="cursor-pointer text-gray-500" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.229 13.8679C19.913 16.0639 16.96 19.75 12 19.75C11.037 19.75 10.0861 19.604 9.17408 19.315C8.77908 19.19 8.56105 18.769 8.68605 18.374C8.81005 17.978 9.23496 17.762 9.62696 17.885C10.392 18.127 11.19 18.25 12 18.25C16.222 18.25 18.7901 15.02 19.9441 13.094C20.3521 12.418 20.3521 11.581 19.9461 10.907C19.6001 10.324 19.177 9.72798 18.72 9.17898C18.455 8.85998 18.4991 8.38707 18.8181 8.12307C19.1381 7.85807 19.61 7.90199 19.875 8.21999C20.381 8.82899 20.8509 9.49199 21.2329 10.137C21.9259 11.284 21.926 12.7159 21.229 13.8679ZM10.063 14.9981L3.53004 21.531C3.38404 21.677 3.19201 21.751 3.00001 21.751C2.80801 21.751 2.61598 21.678 2.46998 21.531C2.17698 21.238 2.17698 20.763 2.46998 20.47L5.64503 17.2949C4.31703 16.1499 3.35205 14.837 2.76905 13.866C2.07505 12.716 2.07501 11.2841 2.77101 10.1331C4.08701 7.93708 7.04001 4.251 12 4.251C13.835 4.251 15.565 4.76994 17.155 5.78494L20.469 2.47097C20.762 2.17797 21.237 2.17797 21.53 2.47097C21.823 2.76397 21.823 3.23901 21.53 3.53201L10.065 14.9971C10.065 14.9971 10.065 14.9981 10.064 14.9981C10.063 14.9981 10.063 14.9971 10.063 14.9981ZM9.6089 13.3311L13.3311 9.60891C12.9291 9.38191 12.478 9.251 12 9.251C10.484 9.251 9.25099 10.484 9.25099 12.001C9.25099 12.478 9.3829 12.9291 9.6089 13.3311ZM6.70704 16.232L8.51905 14.4199C8.02405 13.7169 7.75099 12.882 7.75099 11.999C7.75099 9.65605 9.65701 7.74905 12 7.74905C12.884 7.74905 13.7179 8.02211 14.4209 8.51711L16.052 6.88601C14.787 6.14501 13.432 5.74807 12 5.74807C7.77801 5.74807 5.20992 8.97808 4.05592 10.9041C3.64792 11.5801 3.64797 12.4171 4.05397 13.0911C4.59097 13.9881 5.48304 15.201 6.70704 16.232ZM14.708 12.4351C14.528 13.5951 13.594 14.53 12.436 14.709C12.027 14.772 11.7461 15.155 11.8091 15.564C11.8671 15.935 12.1861 16.2 12.5491 16.2C12.5871 16.2 12.6261 16.1969 12.6641 16.1909C14.4911 15.9089 15.908 14.4921 16.19 12.6641C16.253 12.2541 15.973 11.8721 15.563 11.8081C15.163 11.7471 14.771 12.0251 14.708 12.4351Z" fill="currentColor" />
                            </svg>
                            : <svg onClick={() => setPassType("Password")} className="cursor-pointer text-gray-500" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M21.2352 10.1379C19.9222 7.93894 16.9751 4.25 12.0001 4.25C7.02511 4.25 4.07801 7.93894 2.76501 10.1379C2.07801 11.2859 2.07801 12.7131 2.76501 13.8621C4.07801 16.0611 7.02511 19.75 12.0001 19.75C16.9751 19.75 19.9222 16.0611 21.2352 13.8621C21.9222 12.7131 21.9222 11.2869 21.2352 10.1379ZM19.9481 13.092C18.7981 15.018 16.2351 18.25 12.0001 18.25C7.76511 18.25 5.20212 15.019 4.05212 13.092C3.65012 12.418 3.65012 11.581 4.05212 10.907C5.20212 8.98098 7.76511 5.74902 12.0001 5.74902C16.2351 5.74902 18.7981 8.97998 19.9481 10.907C20.3511 11.582 20.3511 12.418 19.9481 13.092ZM12.0001 7.75C9.65611 7.75 7.75011 9.657 7.75011 12C7.75011 14.343 9.65611 16.25 12.0001 16.25C14.3441 16.25 16.2501 14.343 16.2501 12C16.2501 9.657 14.3441 7.75 12.0001 7.75ZM12.0001 14.75C10.4831 14.75 9.25011 13.517 9.25011 12C9.25011 10.483 10.4831 9.25 12.0001 9.25C13.5171 9.25 14.7501 10.483 14.7501 12C14.7501 13.517 13.5171 14.75 12.0001 14.75Z" fill="currentColor" />
                            </svg>
                        }
                    </div>
                </div>
                <div>
                    <label className="font-semibold text-gray-800">{t("Referral Code")}</label>
                    <input type="text" value={allData?.refercode} onChange={(e) => setAllData({ ...allData, refercode: e.target.value })} className="w-full px-[10px] py-[8px] border rounded-[10px] mt-1 focus-within:ring-2 focus-within:ring-[--bg-color] transition-all outline-none" placeholder={t("Enter referral code(optional)")} />
                </div>
            </div>

            <button type="submit" className="w-full mt-8 h-[45px] bg-[--bg-color] text-white rounded-[10px] font-semibold italic tracking-[1px] hover:bg-[--bg-color-hover] transition-colors">
                {apiLoading === "LetsGo"
                    ? <BtnLoader CustomeStyle={"bg-white"} />
                    : t("Let's Go")}
            </button>

            <div className="flex items-center justify-center mt-4 group text-gray-800">
                <button onClick={() => setPageStep((prev) => prev - 1)} className="flex items-center gap-2">
                    <svg width="18" height="18" className="group-hover:text-black" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="currentColor" />
                    </svg>
                    <span className="group-hover:text-black">{t("Back")}</span>
                </button>
            </div>

        </form>

    </div>

}